// Palette of handle colors — users pick one per post.
export const HANDLE_COLORS = [
  "#ff00ff", "#00ff9f", "#00ffff", "#ffff00", "#ff6600",
  "#cc99ff", "#00ff00", "#66ccff", "#33ff99", "#ff3399",
  "#99ffcc", "#ffcc00", "#ff0066", "#ffaa00", "#cc66ff", "#66ff66",
];

const API = "/api/posts";

/** Fetch recent posts from the backend. Returns an array shaped like:
 *  [{ id, name, message, color, ts }, ...] (newest first). */
export async function fetchPosts() {
  const r = await fetch(API, { cache: "no-store" });
  if (!r.ok) throw new Error(`GET ${API} failed: ${r.status}`);
  return await r.json();
}

/** POST a new message. Returns { id, ts } on success. Throws on HTTP error.
 *  4xx responses carry a { detail } field that we surface as the error msg. */
export async function submitPost({ name, message, color }) {
  const r = await fetch(API, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, message, color }),
  });
  if (!r.ok) {
    let detail = `POST ${API} failed: ${r.status}`;
    try {
      const j = await r.json();
      if (j && j.detail) detail = typeof j.detail === "string"
        ? j.detail
        : JSON.stringify(j.detail);
    } catch (_) {}
    const err = new Error(detail);
    err.status = r.status;
    throw err;
  }
  return await r.json();
}
